import styled, { css } from "styled-components";

export const PartnersPageRoot = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
        gap: 20px;
    `,
);
